import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  align-items: center;
  cursor: ${props => (props.disabled && !props.isToggle ? 'not-allowed' : 'pointer')};
`;

const IconOverlay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.5s ease;
  border-radius: 50%;
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
  &:focus {
    background-color: rgba(255, 255, 255, 0.1);
    outline: none;
  }
  height: 2em;
  width: 2em;
  margin: 4px 0;
`;

const IconLabel = styled.label`
  margin-left: 0.5em;
`;

export default {
  Container,
  IconOverlay,
  IconLabel,
};
